import React from 'react';
import { Input } from 'antd';

const ReusableSearchInput = ({
  placeholder = 'Search here...',
  size = 'medium',
  width = 250,
  mt = 0, // px values
  mb = 0, // px values (negative supported via style)
  value,
  onSearch,
  onChange,
  style,
  className = '',
}) => {
  const { Search } = Input;
  return (
    <div
      className={`${className} inline-flex`}
    //  style={{ marginTop: mt, marginBottom: mb, ...style }}
    >
      <Search
        placeholder={placeholder}
        size={size}
        value={value}
        onSearch={onSearch}
        onChange={onChange}
        style={{ width }}
      />
    </div>
  );
};

export default ReusableSearchInput;
